import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import { _win } from 'core/variables';

export default new RouteHandler({
    init() {
        $events.on(':productSelect', 'change', (e) => {
            const $header = $(':header');
            const $target = $(`#${e.target.value}`);

            _win.scrollTo(0, Number(`${$target.offset().top - $header.height()}`));
        });
    },
});